import React from 'react';


import { Mail } from 'lucide-react';

export default function BulkActionsBar({ selectedCount, onClearSelection, onBulkAction, onBulkEmail, selectedApplications }) {
  // Determine current status of selected applications
  const currentStatuses = [...new Set(selectedApplications?.map(app => app?.status))];
  const isConfirmed = currentStatuses?.includes('bestätigt');
  const isProcessing = currentStatuses?.includes('processing');
  const hasUnconfirmed = currentStatuses?.includes('unbestätigt');

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-gray-700">
              {selectedCount} {selectedCount === 1 ? 'Antrag' : 'Anträge'} ausgewählt
            </span>
            {hasUnconfirmed && (
              <span className="text-xs text-yellow-700 bg-yellow-100 px-2 py-1 rounded">
                Unbestätigte Anträge können nicht weiterbearbeitet werden
              </span>
            )}
          </div>
          <button
            onClick={onClearSelection}
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Auswahl aufheben
          </button>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onBulkEmail}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium flex items-center gap-2"
          >
            <Mail className="w-4 h-4" />
            Send Bulk Email
          </button>

          {(isConfirmed || isProcessing) && !hasUnconfirmed && (
            <button
              onClick={() => onBulkAction?.('weiter')}
              className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm font-medium"
            >
              {isConfirmed ? 'Weiter (Fahrzeugscheine herunterladen)' : 'Weiter (Status wählen)'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}